import { GetterTree } from 'vuex';
import { EnrollmentModel } from '@descomplica/dex-models';
import { EnrollmentState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<EnrollmentState, RootState> = {
  enrollmentById: (state, enrollmentsGetters) => (enrollmentId: number) => {
    const enrollment = state.enrollments[enrollmentId.toString()];

    return enrollment ? new EnrollmentModel(enrollment, enrollmentsGetters) : undefined;
  },
  getUserEnrollments: (state, enrollmentsGetters) => {
    return Object.values(state.enrollments).map((e) => new EnrollmentModel(e, enrollmentsGetters));
  },
  getClassroomsEnrollments:
    (state, enrollmentsGetters) =>
    (classroomsIds: number[]): EnrollmentModel[] => {
      const enrollments: EnrollmentModel[] = enrollmentsGetters.getUserEnrollments;

      return enrollments.filter((enrollment: EnrollmentModel) =>
        classroomsIds.some(
          (classroomId: number) => classroomId === enrollment.classroomByClassroomId,
        ),
      );
    },
  startedEnrollmentsByUserId: (state, enrollmentsGetters) => (userId: number) => {
    return Object.values(state.enrollments)
      .map((enrollment) => new EnrollmentModel(enrollment, enrollmentsGetters))
      .filter((enrollment: EnrollmentModel) => enrollment.userId === userId);
  },
};

export default getters;
